import React from 'react'


export class Titulo1 extends React.Component {render(){return <h2 className="titulo t1 tEventos">{this.props.content}</h2>}}
export class Titulo2 extends React.Component {render(){return <h2 className="titulo t2 tEventos">{this.props.content}</h2>}}
export class Titulo3 extends React.Component {render(){return <h2 className="titulo t3 tEventos">{this.props.content}</h2>}}
export class Titulo4 extends React.Component {render(){return <h2 className="titulo t4 tEventos">{this.props.content}</h2>}}
export class Titulo5 extends React.Component {render(){return <h2 className="titulo t5 tEventos">{this.props.content}</h2>}}



// WEBPACK FOOTER //
// ./src/components/Layout/Titulo.js